import {
  loadFixture, paginate, findInTree, removeFromTree, nextId, parseBody, parseQuery, urlParam,
  CURRENT_USER_PROFILE_REF, groupIdentifierFromUrl, groupFixtureName,
} from '../mockDataStore';

const FEED_LIST = /^\/?api\/v1\/groups\/[\w-]+\/feed\/?(\?.*)?$/;
const FEED_DETAIL = /^\/?api\/v1\/groups\/[\w-]+\/feed\/(\d+)\/?$/;
const POST_LIKE = /^\/?api\/v1\/groups\/[\w-]+\/group-discussion\/(\d+)\/like\/?$/;
const POST_CONFIG = /^\/?api\/v1\/groups\/[\w-]+\/group-discussion\/(\d+)\/config\/?$/;

export default function registerFeedMocks(mock) {
  mock.onGet(FEED_LIST).reply(async (config) => {
    const feed = await loadFixture(groupFixtureName('feed/feed', groupIdentifierFromUrl(config.url)));
    return [200, paginate(feed.results, parseQuery(config.url))];
  });

  mock.onPost(FEED_LIST).reply(async (config) => {
    const feed = await loadFixture(groupFixtureName('feed/feed', groupIdentifierFromUrl(config.url)));
    const body = parseBody(config);
    const created = {
      id: nextId(feed.results.flatMap((post) => [post, ...post.sub_discussions])),
      content: body.content || '',
      photo: body.photo instanceof Blob ? URL.createObjectURL(body.photo) : null,
      posted_datetime: new Date().toISOString(),
      profile: CURRENT_USER_PROFILE_REF,
      likes: [],
      is_deleted: false,
      is_flagged_as_offensive: null,
      is_hidden: false,
      sub_discussions: [],
    };

    // A `parent_post` means this is a reply — nest it under that post's sub_discussions
    // (matching the tree shape GET returns) instead of appending it as a new top-level post.
    const parentId = body.parent_post ? Number(body.parent_post) : null;
    if (parentId) {
      const parent = findInTree(feed.results, parentId);
      if (!parent) return [404, { message: 'Not found.' }];
      parent.sub_discussions.push(created);
    } else {
      feed.results.push(created);
      feed.count += 1;
    }

    return [201, created];
  });

  mock.onDelete(FEED_DETAIL).reply(async (config) => {
    const feed = await loadFixture(groupFixtureName('feed/feed', groupIdentifierFromUrl(config.url)));
    removeFromTree(feed.results, Number(urlParam(config, FEED_DETAIL)));
    feed.count = feed.results.length;
    return [200, {}];
  });

  mock.onPost(POST_LIKE).reply(async (config) => {
    const feed = await loadFixture(groupFixtureName('feed/feed', groupIdentifierFromUrl(config.url)));
    const post = findInTree(feed.results, Number(urlParam(config, POST_LIKE)));
    if (!post) return [404, { message: 'Not found.' }];
    if (!post.likes.some((like) => like.profile.id === CURRENT_USER_PROFILE_REF.id)) {
      post.likes.push({ profile: CURRENT_USER_PROFILE_REF });
    }
    return [200, post];
  });

  mock.onDelete(POST_LIKE).reply(async (config) => {
    const feed = await loadFixture(groupFixtureName('feed/feed', groupIdentifierFromUrl(config.url)));
    const post = findInTree(feed.results, Number(urlParam(config, POST_LIKE)));
    if (!post) return [404, { message: 'Not found.' }];
    post.likes = post.likes.filter((like) => like.profile.id !== CURRENT_USER_PROFILE_REF.id);
    return [200, post];
  });

  mock.onPost(POST_CONFIG).reply(async (config) => {
    const feed = await loadFixture(groupFixtureName('feed/feed', groupIdentifierFromUrl(config.url)));
    const post = findInTree(feed.results, Number(urlParam(config, POST_CONFIG)));
    if (!post) return [404, { message: 'Not found.' }];
    post.config = { ...post.config, ...parseBody(config) };
    return [200, post];
  });
}
